module.exports = __webpack_public_path__ + "static/media/CRITICAL_DOC.c663d66d.svg";